export default "__VITE_ASSET__b5095fe1__"